import styled from '@emotion/styled';

export const StyledFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 24px 0;

  & > * + * {
    margin-left: 15px;
  }
`;
